<div class="input-container">
  <input
    #numberInput
    type="text"
    class="form-control"
    [id]="id"
    [placeholder]="placeholder"
    [value]="formattedValue"
    (input)="onInput($event)"
    (focus)="onFocus()"
    (blur)="onBlur()"
    [ngClass]="{
      'is-invalid': isInValid,
      'required-mark': requiredMark,
      'input': disabled === true
    }"
    [attr.disabled]="(disabled || isHeader) ? true : null"
    [attr.aria-invalid]="isInValid ? 'true' : null"
    [attr.aria-describedby]="ariaDescribedby || null"
    [attr.aria-required]="ariaRequired"
  >
  <div class="stepper-buttons" *ngIf="showSteppers && !(disabled || isHeader)">
    <a
      type="button"
      aria-label="Increase value"
      (mousedown)="handleButtonMouseDown($event)"
      (click)="increment($event)"
      class="stepper-btn step-up"
    ></a>
    <a
      type="button"
      aria-label="Decrease value"
      (mousedown)="handleButtonMouseDown($event)"
      (click)="decrement($event)"
      class="stepper-btn step-down"
    ></a>
  </div>
</div>
